var React = require('react');
var ReactNative = require('react-native');
var createReactClass = require('create-react-class');
var {
  AppRegistry,
  View,
  Image,
  Platform,
  findNodeHandle
} = ReactNative;

var Globals = require('../Globals');
import Drawer from 'react-motion-drawer';

var DrawerWrapper = createReactClass(
{
  getDefaultProps : function()
  {
    return {
      onOpen: ()=>{},
      onClose: ()=>{},
      content: null,
    }
  },

  getInitialState : function()
  {
    return {
      open:false
    }
  },

  componentDidMount : function()
  {

  },

  open : function()
  {
    this._draw.open();
  },

  close : function()
  {
    this._draw.close();
  },

  toggle : function()
  {
    if( this._isOpen ) this.close();
    else this.open();
  },

  _isOpen : false,
  render: function()
  {
    var thisThing = this;
    return <View style={{position:'absolute', top:0, left:0, right:0, bottom:0, paddingTop:Globals.ACTION_BAR_HEIGHT}} >
      <Drawer ref={(a)=>{if( a != null ) this._draw = a;}} noTouchOpen={true} handleWidth={0} onChange={(a)=>
      {
        thisThing._isOpen = a;
        if( a ) thisThing.props.onOpen();
        else thisThing.props.onClose();
      }} drawerStyle={{top:Globals.ACTION_BAR_HEIGHT, marginRight:50}}
      >
      <View style={{flex:1, alignSelf:'stretch', backgroundColor:'red', height:'100%'}}>{this.props.content}</View>
      </Drawer>
      {this.props.children}
    </View>
  }
});

DrawerWrapper.tweenPresets = {parallax:1}

export default DrawerWrapper;



// WEBPACK FOOTER //
// ./src/wrappers/react-native-drawer-wrapper.js